import { format } from "date-fns";

export default function TableCellDate({ value, options }) {
  if (!value) return "-";

  const date = new Date(value);
  let formatted = "";

  switch (options.formatType) {
    case "short": // 09/07/25
      formatted = format(date, "dd/MM/yy");
      break;
    case "long": // 9 July 2025
      formatted = format(date, "d MMMM yyyy");
      break;
    case "withSuffix": // 9th Jul 2025
      formatted = format(date, "do MMM yyyy");
      break;
    case "time": // 14:30
      formatted = format(date, "HH:mm");
      break;
    case "datetime": // 09 Jul 2025, 14:30
      formatted = format(date, "d MMM yyyy, h:mm a");
      break;
    case "weekday": // Wed, 9 Jul 2025
      formatted = format(date, "EEE, d MMM yyyy");
      break;
    default: // fallback ISO
      formatted = format(date, "yyyy-MM-dd");
  }

  return <span className="font-semibold">{formatted}</span>;
}
